// extracted by mini-css-extract-plugin
export default {"facebook":"mailinglist_facebook__8sMev","instagram":"mailinglist_instagram__tf+-Q","form":"mailinglist_form__vMFAg","invalid":"mailinglist_invalid__NLNbu"};